// Locate2u operates this portal ("Powered by Locate2u"); the brand mark shown
// is the customer's — FedEx. This deployment is FedEx-only, so the logo is
// hardcoded rather than tenant-configurable (white-label removed 2026-07-02;
// functional settings live in portalSettings.tsx instead).
export const BRAND = {
  name: 'Locate2u Safety & Compliance',
  logoUrl: '/fedex-logo.png',
  // Reversed (light-on-dark) mark for use on the dark/purple auth brand panels.
  logoReverseUrl: '/fedex-logo-reverse.png',
  logoAlt: 'FedEx',
  // Displayed help contact for vendors (login + expired-session screens). This is
  // NOT the outbound sender: emails still send from compliance@locate2u.com, the
  // SES-verified identity (see SENDER in apps/api/src/lib/email.ts). Kept in step
  // with SUPPORT_ADDRESS in that same file, including the underscored casing.
  supportEmail: 'AU_Vendor_Support@FedEx.com',
} as const;
